import { useState, useEffect, forwardRef, useMemo } from 'react';
import { Link, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Pagination,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';

import styledComponent from "styled-components";

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Rowing } from '@material-ui/icons';
import jwtDecode from 'jwt-decode';

import imgNotFound from '../../assets/icons/no-image.png'

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const ProductsFlashSale = ({
  Cart,
  ProductsData,
  UpdatedCartState,
  UpdatedJmlState,
  UpdatedTotalState,
  UpdatedProductsData,
  UpdatedPage,
  UpdatedPageInfo,
  UpdatedPageSize,
  Page,
  PageInfo,
  PageSize
}) => {
  const [token, setToken] = useState(
    JSON.parse(localStorage.getItem('token')) !== null ? 
        JSON.parse(localStorage.getItem('token')).token :
        null
  );
  const [loading, setLoading] = useState(false);
  
  const [page, setPage] = useState({ value: 1 });
  const [pageInfo, setPageInfo] = useState(null);
  const [pageSize, setPageSize] = useState({ value: 24 });

  const [pageForInfo, setPageForInfo] = useState({ value: 1 });
  const [pageInfoInfo, setPageInfoInfo] = useState(null);
  const [pageInfoSize, setPageInfoSize] = useState({ value: 24 });

  const [search, setSearch] = useState(null);
  const [searchInfo, setSearchInfo] = useState(null);
  const [openInfo, setOpenInfo] = useState(false);
  const [infoStock, setInfoStock] = useState([]);

  const [openAlert, setOpenAlert] = useState(false);
  const [alertStatus, setAlertStatus] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const handleCloseAlert = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setOpenAlert(false);
  };

  const navigate = useNavigate();

  const getProducts = async () => {
    try {
      const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/readystok/list`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
        params: {
            page: Page.value,
            perPage: PageSize.value
        }
      });
      let number = 0;
      UpdatedProductsData(products.data.result.data.map((v) => {
        number+=1;
        return { ...v, no: number };
      }));
      const pageInfoRes = Object.keys(products.data.result)
        .filter((key) => {
            if (key !== 'data') return true;
            return false;
        })
        .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
      UpdatedPageInfo(pageInfoRes);
    } catch (err) {
      console.log(err);
    }
  }

  const handlePage = (event, value) => {
    UpdatedPage({ value });
    window.localStorage.setItem('curPage', value);
    const serviceToken = window.localStorage.getItem('serviceToken');
    const getData = async () => {
        try {
          const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/readystok/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
            params: {
              namaproduk: search,
              page: value,
              perPage: PageSize.value
            }
          });
          let number = 0;
          UpdatedProductsData(products.data.result.data.map((v) => {
            number+=1;
            return { ...v, no: number };
          }));
          const pageInfoRes = Object.keys(products.data.result)
            .filter((key) => {
                if (key !== 'data') return true;
                return false;
            })
            .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
          UpdatedPageInfo(pageInfoRes);
        } catch (err) {
          console.log(err);
        }
    };
    getData();
  };

  const handleAddCart = (item) => {
    const values = {
      idproduk: item.idproduk,
      jmlh: 1,
      harga: item.harga,
      subtotal: item.harga * 1
    };

    const addToCart = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/add`, values, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
          }
        });

        const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
          }
        });

        let jmlQ = 0;
        let totalH = 0;
          
        cartData.data.result.forEach((item) => {
          jmlQ += item.jmlh;
          // totalH += item.subtotal;
          if (new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) {
            if (item.jenis === 'gamis' || item.jenis === 'koko') {
              totalH += 100000;
            } else {
              totalH += 50000;
            }
          } else {
            totalH += item.subtotal;
          }
        });
        console.log(jmlQ, totalH);
        UpdatedJmlState(jmlQ);
        UpdatedTotalState(totalH);
        UpdatedCartState(cartData.data.result);

        setAlertStatus('success');
        setAlertMessage('Produk telah ditambahkan ke keranjang');
        setOpenAlert(true);

      } catch (err) {
          console.error(err);
          setAlertStatus('error');
          setAlertMessage(err.response.data.message);
          setOpenAlert(true);
      }
    };
    addToCart();
    getProducts();
  };

  const [selectedValue, setSelectedValue] = useState(
    localStorage.getItem('mode') !== null
        ? localStorage.getItem('mode')
        : 'cantik'
);

  const handleChangeRadio = (event) => {
    localStorage.setItem('mode', event.target.value);
    setSelectedValue(event.target.value);
  };

  const handleExport = () => {
    try {
      window.open(`${process.env.REACT_APP_ADMIN_URL}/readystok/export`);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if(!verifyToken(token)){
      localStorage.removeItem('token');
      navigate('/');
    }
  }, [])

  return (
    <div style={{ minHeight: '80vh', padding: '0px 18px 50px 18px'}}>
      <Snackbar
        open={openAlert}
        autoHideDuration={2500}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        key={'top' + 'center'}
      >
          <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
              {alertMessage}
          </Alert>
      </Snackbar>
      <Grid container spacing={2}>
        <Grid item xs={12} my={2}>
            <Typography variant="h5" fontWeight="700">Ready Stock</Typography>
        </Grid>
        <Grid item xs={12} my={2}>
          <RadioGroup
              aria-label="ringtone"
              name="ringtone"
              value={selectedValue}
              onChange={handleChangeRadio}
              sx={{ flexDirection: 'row' }}
          >
              <FormControlLabel
                  value="hemat"
                  key={0}
                  control={<Radio />}
                  label="Mode Hemat"
              />
              <FormControlLabel
                  value="cantik"
                  key={1}
                  control={<Radio />}
                  label="Mode Cantik"
              />
          </RadioGroup>
        </Grid>
        <Grid item xs={12} my={1}>
          <Formik
            initialValues={{ namaproduk: null }}
            validate={async (values) => {
              const errors = {};
              if (!values.namaproduk) {
                errors.namaproduk = 'Required';
              }
              if (values.namaproduk === '') {
                setPageForInfo({ value: 1 });
                setSearchInfo(null);
                window.localStorage.removeItem('searchReadyStock');
                const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/readystok/list`, {
                  headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  },
                  params: {
                      page: 1,
                      perPage: PageSize.value
                  }
                });
                let number = 0;
                UpdatedProductsData(products.data.result.data.map((v) => {
                  number+=1;
                  return { ...v, no: number };
                }));
                setSearch(null);
                const pageInfoRes = Object.keys(products.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                UpdatedPageInfo(pageInfoRes);
              }
              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              UpdatedPage({ value: 1 });
              window.localStorage.setItem('searchReadyStock', values.namaproduk);
              window.localStorage.setItem('curPage', 1);
              try {
                const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/readystok/list`, {
                  headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  },
                  params: {
                      namaproduk: values.namaproduk,
                      page: 1,
                      perPage: PageSize.value
                  }
                });
                let number = 0;
                UpdatedProductsData(products.data.result.data.map((v) => {
                  number+=1;
                  return { ...v, no: number };
                }));
                setSearch(values.namaproduk);
                const pageInfoRes = Object.keys(products.data.result)
                  .filter((key) => {
                      if (key !== 'data') return true;
                      return false;
                  })
                  .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                UpdatedPageInfo(pageInfoRes);
                setLoading(false);
                setSubmitting(false);
              } catch (err) {
                console.log(err);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                  <Paper
                    component="div"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      required
                      name="namaproduk"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Cari produk"
                      inputProps={{ 'aria-label': 'cari produk' }}
                    />
                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                </form>
            )}
          </Formik>
        </Grid>
        <Grid item xs={12} my={2} container justifyContent="flex-end">
          <Button variant="outlined" onClick={handleExport}>
            Export Product
          </Button>
        </Grid>
        {localStorage.getItem('mode') !== null && localStorage.getItem('mode') === 'hemat' && (
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '66vh', sm: 740, md: 800} }}>
              <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 450 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Nama Produk</TableCell>
                    <TableCell>Harga</TableCell>
                    <TableCell>Stok</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ProductsData.map((item) => (
                    <TableRow
                      key={item.idproduk}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>{item.namaproduk}</TableCell>
                      <TableCell align="right">{item.harga}</TableCell>
                      <TableCell>{item.stock}</TableCell>
                      <TableCell>
                        <Button
                          fullWidth
                          variant="contained"
                          size="small"
                          onClick={() => {
                            handleAddCart(item);
                            // UpdatedCart(true);
                          }}
                        >
                          Beli
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}        
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
        {(localStorage.getItem('mode') === null || localStorage.getItem('mode') === 'cantik') &&
          ProductsData.map((item) => (
          <Grid item xs={6} sm={6} md={3}>
            <Card sx={{ maxWidth: 345, minHeight: { xs: 353, sm: 320, md: 350 } }}>
              <CardMedia
                component="img"
                // height="240"
                sx={{height: { xs: 240, sm: 320, md: 350 }}}
                image={`https://wnj.web.id/distributor/foto/`+item.foto}
                alt={item.namaproduk}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src= imgNotFound;
                }}
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="subtitle2"
                  fontWeight="700"
                  component="div"
                  sx={{
                    minHeight: '44px'
                  }}
                >
                  {item.namaproduk}
                </Typography>
                <Typography variant="body2" fontWeight="700" color="text.secondary">
                  {(new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) ? (
                    <>
                      Rp.&nbsp; 
                      <s>{item.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</s>&nbsp;
                      {(item.jenis === 'gamis' || item.jenis === 'koko') ? (
                        <>
                          {(100000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </>
                      ) : (
                        <>
                          {(50000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      Rp. {item.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                    </>
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ({item.stock}) pcs
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant="contained"
                  size="small"
                  onClick={() => {
                    // UpdatedCart(true);
                    handleAddCart(item);
                  }}
                >
                  Beli
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Stack spacing={2}>
            <Pagination
              count={PageInfo ? PageInfo.last_page : 10}
              color="primary"
              page={Page.value}
              onChange={handlePage}
              variant="outlined" shape="rounded" />
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductsFlashSale;